/**
 * Public routes accessible without authentication.
 * These routes will not require users to be logged in.
 * @type {(string|RegExp)[]}
 */
export const publicRoutes = [
  "/", 
  "/qna",
  "/questions",
  "/swagger",
  "/api/swagger",
  "/api/qna",
  "/api/docs",
  "/api/documents", 
  "/auth/new-verification",
  "/auth/new-password",
  "/api/acknowledge-document",
  "/certificates",
  "/cert-iframe",
  "/api/auth/session",
  "/api/auth/csrf",

  // ✅ IT Assets public read-only view (no login required)
  "/it-assets-view",

  // ✅ Catalog Tracker — public read-only (scan buttons are role-gated client-side)
  "/catalog-tracker",
  /^\/catalog-tracker\/[^/]+$/,  // /catalog-tracker/any-slug

  // ✅ Generic Greeting Routes (Matches /greetings and /greetings/founding)
  "/greetings",
  /^\/greetings\/[^/]+$/,  // Matches /greetings/any-slug

  // ✅ Generic Certificate Routes
  "/certificates",
  "/cert-iframe",

  // ✅ Generic VCard Routes
  /^\/vcard\/[^/]+$/,      // Matches /vcard/any-slug

  // ✅ Specific Documents (If you strictly need this ID public)
  "/documents/cm35m1fr30001y5p7pz5kxdbx",
];

/**
 * Authentication routes.
 * These routes redirect logged-in users to the default post-login page.
 * @type {string[]}
 */
export const authRoutes = [
  "/auth/login",
  "/auth/register",
  "/auth/error",
  "/auth/reset",
  "/", // Careful: This means logged-in users hitting home redirects to dashboard
];

/**
 * Helper to check if a route is public.
 * Automatically ignores locale prefixes (/en-us, /ar-sa).
 */
export function isPublicRoute(pathname: string) {
  // 1️⃣ Normalize the URL to ensure it's just a pathname
  const fullPath = new URL(pathname, "http://localhost").pathname;

  // 2️⃣ Strip the locale prefix (e.g., "/en-us/greetings" -> "/greetings")
  const cleanPath = fullPath.replace(/^\/(en-us|ar-sa)/, "") || "/";

  // console.log(`🧐 Checking: "${fullPath}" (Clean: "${cleanPath}")`);

  // 3️⃣ Check against the public list
  return publicRoutes.some((route) => {
    if (route instanceof RegExp) {
      return route.test(cleanPath) || route.test(fullPath);
    }
    return cleanPath === route || fullPath === route;
  });
}

export const apiAuthPrefix = "/api/auth";
export const DEFAULT_LOGIN_REDIRECT = "/my-profile";